export default {
  有效交易量达标即可获得:`유효 거래량이 목표치에 도달하면 리워드를 받을 수 있습니다. 자세한 내용은  <a href="#pay-session5">안내 사항</a>을 참조해 주세요.`,
  
  交易领薪计划: "펀드매니저 프로그램",
  为了鼓励交易者提升交易水平: `트레이딩 실력을 증명하고 최대 연 <span class="red">18<span class="sRed">%</span></span> 운용 수수료를 획득해보세요`,
  加入交易社区: "",
  即刻发起交易信号: "거래 시그널 공유",
  无限奖励月月拿: "월간 무제한 보너스",
  优享11个专属大礼: "10가지 전용 혜택",
  即刻加入: "지금 신청하기",
  交易员等级奖励机制: `트레이더 레벨 및 리워드`,
  EBC基于跟随人数和资金提供五档奖励:
    "팔로워 수와 자금에 따라 5가지 등급의 보상을 제공합니다. 거래 랏 수는 제한하지 않으며, 등급 측정은 시장 수용도를 기준으로 합니다. ",
  "/月": "/월",
  精英交易员: "엘리트 트레이더",
  管理资金量: "관리자금",
  跟随账户数: "팔로우 수",
  大师交易员: "마스터 트레이더",
  冠军交易员: "챔피언 트레이더",
  明星交易员: "스타 트레이더",
  资金管理费: "1% 관리 수수료",
  传奇交易员: "레전드 트레이더",
  多层次的增值服务: "다양한 혜택",
  EBC提供多达11项增值服务:
    "본 프로그램은 총 10가지 전용 혜택을 제공하며, 시그널 홍보를 적극 지원합니다.",

  "7×24小时优先客服": "7x24시간 온라인 고객 상담 서비스",
  金融投资经典书籍礼遇: "투자 관련 도서 무료 증정",
  专属VPS赞助: "독적점인 VPS 후원",
  订单流软件1年使用权: "오더 플로우 툴 액세스 권한 1년",
  EBC定制大礼包: "EBC 프리미엄 선물 세트",
  信号优先置顶展示: "공급자 표시",
  受邀参观海外办公室: "해외 지사 방문 기회 제공",
  巴萨球星联名礼包: "FC 바르셀로나 스타 선수 한정판 선물 세트",
  巴萨赛场传奇之旅: "FC 바르셀로나 경기장 투어",
  品牌战略合作: "전략적  브랜드 파트너십",
  全球金融资源管家服务: "글로벌 금융 자산 관리 서비스",
  五维指标评价系统: "5차원 지표 평가 시스템",
  为交易员信号提供公开透明的评估:
    "트레이더의 시그널에 대해 명확하고 투명한 평가를 제공함으로써, 트레이딩 스타일을 보다 분명히 드러내고 더 많은 팔로워를 유치할 수 있습니다.",
  收益率: "수익률",
  历史收益率: "과거 수익률이 높을수록 유리합니다.",
  最大回撤: "최대 손실",
  衡量风控能力: "위험 관리 수준을 보여주는 지표이며, 낮을수록 리스크가 낮습니다.",
  获利系数: "프로핏 팩터",
  利润因子: "프로핏 팩터가 높을수록 수익성이 더 높습니다. ",
  夏普比率: "샤프 비율",
  每份风险的收益: "위험 단위당 수익률을 나타내며, 수치가 높을수록 더 우수합니다.",
  标准差: "표준편차",
  收益波动率: "변동성 측정, 수치가 낮을수록 안정적입니다.",
  以上数据仅供参考: "해당 데이터는 참고용입니다.",
  活动须知: "안내 사항",
   list: [
    {
      label: "1.팔로워 정의",
      value: [
        {label:'팔로워 자금 = 계좌 잔액 ÷ 팔로우 중인 신호 제공자 수',value:[]},
        {label:'팔로우 제한: 각 계정은 동시에 최대 10명의 시그널 제공자(트레이더)를 팔로우할 수 있습니다.',value:[]},
        {label:'유효 팔로워 수: 팔로워 자금이 500달러 이상인 계좌만 유효 팔로워 수로 집계됩니다. 500달러 미만의 계좌는 팔로워 자금이나 유효 팔로워 수에 포함되지 않습니다.​',value:[]},
        {label:'※ 동일한 EBC 계정 내의 여러 거래 계좌가 동일한 시그널을 팔로우하고 있는 경우, 1명의 팔로워로 간주됩니다.',value:[]},
        {label:'운용자산(AUM): 총 팔로워 자금 + 트레이더(시그널 제공자) 계정 잔액',value:[]},
        // {label:'데이터 산정 제외 기준: 트레이더가 본인 계정을 통해 자신을 팔로우하는 경우, 해당 계좌는 유효 팔로워 수와 팔로워 자산 규모 계산에서 제외됩니다.',value:[]}
      ],
    },
    {
      label: "2.레벨 활성화 및 리워드 기준",
      value: [
        {label:'레벨 활성화:레벨은 매시간 시스템에 의해 자동 평가됩니다.운용 자산(AUM)과 유효 팔로워 수가 특정 레벨의 기준을 모두 충족할 경우, 해당 레벨은 유효한 것으로 간주됩니다.',value:[]},
        {label:'리워드 기준(모든 조건을 충족해야 함)',
          value:['트레이더는 한 달 동안 매일 해당 레벨 요건을 유지해야 합니다.',
            {innerLabel:'유효 거래량(랏) ≥ 트레이더(시그널 제공자)의 일일 평균 잔고 × 0.2%:',innerValue:['유효 거래량 = 월간 총 청산 거래량 + 순오픈포지션(순오픈포지션 = 총 오픈 거래량 − 동일 심볼 내 헤지 포지션)',
            '일일 평균 잔액 = 트레이더의 일별 잔액 합계 ÷ 해당 월의 일수',
            '미국 주식 및 ETF는 유효 거래량 산정에서 제외됩니다.']}
            ]},
        {label:'보너스 산정 및 지급',value:['일일 평균 AUM = 일일 AUM의 합계 ÷ 해당 월의 일수','월간 보너스 = (일일 평균 AUM × 운용 수수료율) ÷ 12','매월 말일을 기준으로 정산하며, 익월 첫째 주에 전월 리워드를 계산한 후 심사 완료 시 시그널 계좌에 직접 지급됩니다. 지급 계좌를 변경하고자 하실 경우, 고객지원팀으로 문의해 주시기 바랍니다.','본 이벤트는 인증된 고객만을 대상으로 합니다. 약관 및 대상 고객의 정의에 대한 최종 해석 권한은 EBC에 있습니다.']}
      ],
    }
  ],
  年化资金管理费: "연간 운용 수수료",
};
